import { isExperimentalFeatureEnabled } from '@datadog/browser-core';
import { StatusType } from './logger';
export function reportRawError(error, sender) {
    var messageContext = {
        date: error.startClocks.timeStamp,
        error: {
            kind: error.type,
            origin: error.source,
            stack: error.stack,
        },
    };
    if (isExperimentalFeatureEnabled('forward-logs')) {
        messageContext.origin = error.source;
    }
    sender.sendToHttp(error.message, messageContext, StatusType.error);
}
//# sourceMappingURL=reportRawError.js.map